// productUgcComponent is only implemented in UOCom

export function init() {
    return _.noop();
}
